<template>
  <div class="page ann-page">
    <template v-if="mainTab === 'platform'">
      
      <div class="ann-sticky-top">
        <div class="sub-head">
          <div class="sub-tabs">
            <button
                v-for="t in mainTabs"
                :key="t.key"
                type="button"
                class="sub-tab"
                :class="{ active: mainTab === t.key }"
                @click="mainTab = t.key"
            >
              {{ t.label }}
            </button>
          </div>
          <van-icon name="replay" class="replay" @click="refreshAll" />
        </div>
        <div class="filter-row">
          <van-icon name="search" class="search-ico" @click="showSearch = true" />
          <div class="chips">
            <button
                v-for="c in platformChips"
                :key="c"
                type="button"
                class="chip"
                :class="{ on: activeChip === c }"
                @click="onChip(c)"
            >
              {{ c }}
            </button>
          </div>
        </div>
      </div>

      <div class="ann-pull-wrap">
        <van-pull-refresh v-model="refreshing" @refresh="onPullRefresh">
        <div v-if="loading && rawList.length === 0" class="state-wrap">
          <van-loading size="28" />
        </div>
        <van-empty v-else-if="!loading && filteredList.length === 0" description="暂无公告" />

        <div v-else class="card-list">
          <div
              v-for="row in filteredList"
              :key="row.notice_id || row.detail_url"
              class="ann-card"
              @click="openDetail(row)"
          >
            <div class="ann-card-main">
              <div class="ann-title">{{ displayTitle(row) }}</div>
              <div class="ann-meta">
                <span class="cat-tag">{{ row.category || '公告' }}</span>
                <span class="ann-time">{{ row.publish_time }}</span>
              </div>
            </div>
            <div class="ann-thumb-wrap">
              <img
                  v-if="thumbUrl(row.cover_img)"
                  :src="thumbUrl(row.cover_img)"
                  class="ann-thumb"
                  alt=""
              >
              <div v-else class="ann-thumb ph">{{ row.category || '公告' }}</div>
              <button
                  type="button"
                  class="fav-btn"
                  @click.stop="toggleStar(row.notice_id)"
              >
                <van-icon :name="isStarred(row.notice_id) ? 'like' : 'like-o'" />
                关注
              </button>
            </div>
          </div>
        </div>
        </van-pull-refresh>
      </div>
    </template>

    <template v-else>
      <div class="ann-sticky-top ann-sticky-top--solo">
        <div class="sub-head">
          <div class="sub-tabs">
            <button
                v-for="t in mainTabs"
                :key="t.key"
                type="button"
                class="sub-tab"
                :class="{ active: mainTab === t.key }"
                @click="mainTab = t.key"
            >
              {{ t.label }}
            </button>
          </div>
          <van-icon name="replay" class="replay" @click="refreshAll" />
        </div>
      </div>
      <div class="placeholder-tab">
        <van-empty description="敬请期待" />
      </div>
    </template>

    <van-popup v-model:show="detailOpen" position="bottom" round :style="{ height: '72%' }" class="detail-pop">
      <div class="detail-head">
        <span class="detail-title">{{ detailRow?.title }}</span>
        <van-icon name="cross" class="detail-close" @click="detailOpen = false" />
      </div>
      <div class="detail-sub">
        <span class="cat-tag">{{ detailRow?.category }}</span>
        <span class="ann-time">{{ detailRow?.publish_time }}</span>
      </div>
      <div v-if="detailLoading" class="detail-loading">
        <van-loading size="28" />
        <span>加载正文…</span>
      </div>
      <div
          v-else
          class="detail-body yst-rich"
          v-html="detailHtmlSafe"
      />
    </van-popup>

    <van-popup v-model:show="showSearch" position="top" :style="{ paddingTop: '12px' }">
      <van-search
          v-model="searchKw"
          show-action
          placeholder="搜索标题"
          @search="applySearch"
          @cancel="showSearch = false"
      />
    </van-popup>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import { useRoute } from "vue-router";
import { showToast } from "vant";
import { fetchYstNoticeList, fetchYstNoticeDetailHtml } from "@/api/ystAnnouncements";
import { resolveCdnUrl } from "@/utils/cdn";
import { getStoredPlatformId, PLATFORM_WUYOU } from "@/utils/apiPlatform";
import { getLstToken, getLstAuthorization } from "@/utils/lstSessionStorage";
import { wuyouNoticeList, wuyouNoticeDetail, WUYOU_NOTICE_CATEGORY_PLATFORM, wuyouNoticeListResponseOk, wuyouNoticeDetailResponseOk, unwrapWuyouPayload } from "@/api/wuyou";
const route = useRoute();
const CHIP_ALL = "\u5168\u90E8";
const LST_CATEGORY_CHIPS = [CHIP_ALL, "\u5BC4\u552E\u516C\u544A", "\u6D3B\u52A8\u516C\u544A", "\u4E0A\u65B0\u516C\u544A"];
const mainTabs = [
    { key: "platform", label: "\u5E73\u53F0\u516C\u544A" },
    { key: "news", label: "\u65B0\u95FB\u53D1\u58F0" },
    { key: "rumor", label: "\u8F9F\u8C23\u5899" }
];
const mainTab = ref("platform");
const wuyouChipLabels = ref([CHIP_ALL]);
const wuyouChipToTagId = ref(new Map([[CHIP_ALL, ""]]));
const isWuyouPlatform = computed(() => getStoredPlatformId() === PLATFORM_WUYOU);
const platformChips = computed(() => {
    if (isWuyouPlatform.value)
        return wuyouChipLabels.value.length ? wuyouChipLabels.value : [CHIP_ALL];
    return LST_CATEGORY_CHIPS;
});
const activeChip = ref(CHIP_ALL);
const searchKw = ref("");
const appliedSearch = ref("");
const showSearch = ref(false);
const rawList = ref([]);
const loading = ref(false);
const refreshing = ref(false);
const detailOpen = ref(false);
const detailRow = ref(null);
const detailHtml = ref("");
const detailLoading = ref(false);
const filteredList = computed(() => {
    let rows = rawList.value;
    const chip = activeChip.value;
    if (!isWuyouPlatform.value && chip && chip !== CHIP_ALL) {
        rows = rows.filter((r) => (r.category || "").includes(chip.replace(/公告$/, "")) || (r.category || "").includes(chip));
    }
    const q = appliedSearch.value.trim();
    if (q) {
        rows = rows.filter((r) => (r.title || "").includes(q));
    }
    return rows;
});
const detailHtmlSafe = computed(() => {
    const h = detailHtml.value;
    return h && h.trim() ? h : '<p class="yst-empty">\uFF08\u65E0\u6B63\u6587\uFF09</p>';
});
const STAR_KEY = "lst_ann_starred";
const starred = ref(new Set());
function loadStars() {
    try {
        const raw = localStorage.getItem(STAR_KEY);
        if (raw) {
            const arr = JSON.parse(raw);
            if (Array.isArray(arr))
                starred.value = new Set(arr.map(String));
        }
    }
    catch (e) {
    }
}
function saveStars() {
    try {
        localStorage.setItem(STAR_KEY, JSON.stringify([...starred.value]));
    }
    catch (e) {
    }
}
function isStarred(id) {
    return starred.value.has(String(id));
}
function toggleStar(id) {
    const k = String(id);
    if (starred.value.has(k))
        starred.value.delete(k);
    else
        starred.value.add(k);
    starred.value = new Set(starred.value);
    saveStars();
}
function thumbUrl(cover) {
    if (!cover || !String(cover).trim())
        return "";
    const s = String(cover).trim();
    if (s.startsWith("//"))
        return `https:${s}`;
    return resolveCdnUrl(s);
}
function displayTitle(row) {
    return (row.title || "").trim() || "\uFF08\u65E0\u6807\u9898\uFF09";
}
async function loadList() {
    loading.value = true;
    try {
        if (isWuyouPlatform.value) {
            const token = getLstToken();
            const auth = getLstAuthorization();
            if (!token || !auth) {
                rawList.value = [];
                showToast("\u8BF7\u5148\u5728\u9996\u9875\u4FDD\u5B58\u65E0\u5FE7 Token \u4E0E Authorization");
                return;
            }
            const tagId = wuyouChipToTagId.value.get(activeChip.value) ?? "";
            const res = await wuyouNoticeList(token, auth, {
                pageNum: 1,
                pageSize: 30,
                categoryId: WUYOU_NOTICE_CATEGORY_PLATFORM,
                tagId
            });
            if (!wuyouNoticeListResponseOk(res)) {
                rawList.value = [];
                showToast(res?.msg || "\u52A0\u8F7D\u5931\u8D25");
                return;
            }
            const tagList = res.statistical?.tagList;
            if (Array.isArray(tagList) && tagList.length) {
                const next = [CHIP_ALL, ...tagList.map((t) => String(t.tagName ?? "").trim()).filter(Boolean)];
                const nextMap = new Map([[CHIP_ALL, ""]]);
                for (const t of tagList) {
                    const nm = String(t.tagName ?? "").trim();
                    if (nm)
                        nextMap.set(nm, String(t.tagId ?? ""));
                }
                wuyouChipLabels.value = next;
                wuyouChipToTagId.value = nextMap;
                if (!nextMap.has(activeChip.value))
                    activeChip.value = CHIP_ALL;
            }
            rawList.value = (Array.isArray(res.rows) ? res.rows : []).map((x) => ({
                notice_id: String(x.id ?? ""),
                title: String(x.noticeName ?? "").trim(),
                cover_img: x.image,
                category: String(x.tagName ?? "\u516C\u544A").trim(),
                publish_time: x.createTime ?? "",
                detail_url: String(x.officialUrl ?? "").trim(),
                wuyouId: String(x.id ?? "")
            }));
            return;
        }
        rawList.value = await fetchYstNoticeList();
    }
    catch (e) {
        rawList.value = [];
        showToast(e.message || "\u52A0\u8F7D\u5931\u8D25\uFF0C\u8BF7\u68C0\u67E5\u7F51\u7EDC\u6216\u7A0D\u540E\u91CD\u8BD5");
    }
    finally {
        loading.value = false;
        refreshing.value = false;
    }
}
function onChip(c) {
    activeChip.value = c;
    if (isWuyouPlatform.value)
        loadList();
}
function applySearch() {
    appliedSearch.value = searchKw.value;
    showSearch.value = false;
}
async function onPullRefresh() {
    refreshing.value = true;
    await loadList();
}
function refreshAll() {
    loadList();
}
async function openDetail(row) {
    detailRow.value = row;
    detailHtml.value = "";
    detailOpen.value = true;
    if (isWuyouPlatform.value) {
        const token = getLstToken();
        const auth = getLstAuthorization();
        const nid = row.wuyouId || row.notice_id;
        if (!nid) {
            detailHtml.value = '<p class="yst-empty">\uFF08\u65E0\u6B63\u6587\uFF09</p>';
            return;
        }
        detailLoading.value = true;
        try {
            const res = await wuyouNoticeDetail(token, auth, nid);
            const d = unwrapWuyouPayload(res);
            if (wuyouNoticeDetailResponseOk(res) && d) {
                detailHtml.value = String(d.noticeContent ?? "").trim() ? d.noticeContent : '<p class="yst-empty">\uFF08\u65E0\u6B63\u6587\uFF09</p>';
                detailRow.value = {
                    ...row,
                    title: String(d.noticeTitle ?? row.title ?? "").trim() || row.title,
                    category: String(d.tagName ?? row.category ?? "").trim() || row.category,
                    publish_time: d.createTime ?? row.publish_time
                };
            }
            else {
                detailHtml.value = `<p class="yst-empty">\u52A0\u8F7D\u5931\u8D25\uFF1A${escapeAttr(res?.msg || "\u672A\u77E5\u9519\u8BEF")}</p>`;
            }
        }
        catch (e) {
            detailHtml.value = `<p class="yst-empty">\u52A0\u8F7D\u5931\u8D25\uFF1A${escapeAttr(e.message || "\u672A\u77E5\u9519\u8BEF")}</p>`;
        }
        finally {
            detailLoading.value = false;
        }
        return;
    }
    if (!row.detail_url) {
        detailHtml.value = '<p class="yst-empty">\uFF08\u65E0\u8BE6\u60C5\u94FE\u63A5\uFF09</p>';
        return;
    }
    detailLoading.value = true;
    try {
        detailHtml.value = await fetchYstNoticeDetailHtml(row.detail_url);
    }
    catch (e) {
        detailHtml.value = `<p class="yst-empty">\u52A0\u8F7D\u5931\u8D25\uFF1A${escapeAttr(e.message || "\u672A\u77E5\u9519\u8BEF")}</p>`;
    }
    finally {
        detailLoading.value = false;
    }
}
function escapeAttr(s) {
    return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
watch(mainTab, (m) => {
    if (m === "platform" && rawList.value.length === 0)
        loadList();
});
onMounted(() => {
    const kwParam = route.query.kw;
    if (kwParam) {
        searchKw.value = String(kwParam);
        appliedSearch.value = String(kwParam);
        showSearch.value = false;
    }
    loadStars();
    if (mainTab.value === "platform")
        loadList();
});
</script>

<style scoped>
/* 覆盖全局 .page 的 padding:15px，避免黄条与 Tab 之间出现一条空白 */
.ann-page {
  height: 100%;
  min-height: 0;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--app-bg-page);
  padding: 0;
  box-sizing: border-box;
}


.ann-sticky-top {
  position: sticky;
  top: var(--app-top-banner-h, 0px);
  z-index: 20;
  background: var(--app-surface-glass);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.ann-sticky-top .sub-head {
  border-bottom: 1px solid var(--app-border-subtle);
}

.ann-sticky-top--solo .sub-head {
  border-bottom: none;
}

.sub-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px 4px;
  background: var(--app-surface-glass);
}

.sub-tabs {
  display: flex;
  align-items: center;
  gap: 18px;
  flex: 1;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.sub-tabs::-webkit-scrollbar {
  display: none;
}

.sub-tab {
  border: none;
  background: none;
  padding: 8px 0;
  font-size: 15px;
  color: var(--app-text-secondary);
  white-space: nowrap;
  position: relative;
}

.sub-tab.active {
  color: var(--app-text-primary);
  font-weight: 700;
}

.sub-tab.active::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: 28px;
  height: 3px;
  border-radius: 2px;
  background: var(--app-tab-ink, var(--app-accent));
}

.replay {
  font-size: 20px;
  color: var(--app-text-secondary);
  padding: 8px;
  flex-shrink: 0;
}

.filter-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: var(--app-surface-glass);
  border-bottom: none;
}

.search-ico {
  font-size: 20px;
  color: var(--app-text-secondary);
  flex-shrink: 0;
}

.chips {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  flex: 1;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.chips::-webkit-scrollbar {
  display: none;
}

.chip {
  border: none;
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 13px;
  white-space: nowrap;
  background: rgba(0, 0, 0, 0.05);
  color: var(--app-text-secondary);
}

.chip.on {
  background: var(--app-pill-active-bg, #ff8c42);
  color: var(--app-pill-active-text, #fff);
  font-weight: 600;
}


.ann-pull-wrap {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  margin-top: 10px;
  padding-top: 6px;
  background: var(--app-bg-page);
}

.state-wrap {
  display: flex;
  justify-content: center;
  padding: 48px 0;
}

.card-list {
  padding: 12px 12px 24px;
}

.ann-card {
  display: flex;
  gap: 12px;
  padding: 14px;
  margin-bottom: 10px;
  background: var(--app-surface-glass);
  border-radius: var(--app-card-radius, 14px);
  border: 1px solid var(--app-border-subtle);
  box-shadow: var(--app-card-shadow);
}

.ann-card-main {
  flex: 1;
  min-width: 0;
}

.ann-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--app-text-primary);
  line-height: 1.45;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.ann-meta {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.cat-tag {
  display: inline-block;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
  background: var(--app-badge-sale-bg);
  color: var(--app-badge-sale-text);
}

.ann-time {
  font-size: 12px;
  color: var(--app-text-muted);
}

.ann-thumb-wrap {
  position: relative;
  width: 96px;
  height: 72px;
  flex-shrink: 0;
}

.ann-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

.ann-thumb.ph {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--app-accent-muted), var(--app-accent));
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  text-align: center;
  padding: 4px;
  line-height: 1.2;
}

.fav-btn {
  position: absolute;
  right: 4px;
  bottom: 4px;
  display: flex;
  align-items: center;
  gap: 2px;
  border: none;
  border-radius: 999px;
  padding: 2px 6px;
  font-size: 10px;
  color: #333;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
}

.placeholder-tab {
  padding-top: 48px;
}

.detail-pop {
  display: flex;
  flex-direction: column;
  padding: 0 16px 16px;
}

.detail-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 0 8px;
  border-bottom: 1px solid var(--app-border-subtle);
}

.detail-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--app-text-primary);
  line-height: 1.4;
  flex: 1;
}

.detail-close {
  font-size: 20px;
  color: var(--app-text-muted);
  flex-shrink: 0;
}

.detail-sub {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
}

.detail-loading {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: var(--app-text-muted);
  font-size: 14px;
  padding: 24px;
}

.detail-body {
  flex: 1;
  overflow-y: auto;
  padding-bottom: env(safe-area-inset-bottom);
}


.detail-body.yst-rich :deep(img) {
  max-width: 100% !important;
  height: auto !important;
  display: block;
  margin: 8px 0;
  border-radius: 8px;
}
.detail-body.yst-rich :deep(p),
.detail-body.yst-rich :deep(div),
.detail-body.yst-rich :deep(span) {
  font-size: 15px;
  line-height: 1.65;
  color: var(--app-text-primary);
  word-break: break-word;
}
.detail-body.yst-rich :deep(a) {
  color: var(--app-link-blue);
}
.detail-body.yst-rich :deep(.yst-empty) {
  color: var(--app-text-muted);
  font-size: 14px;
}
</style>
